// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useState } from 'react';

import { useStableCallback } from '@amzn/awsui-component-toolkit/internal';

import { BreadcrumbGroupProps } from '../../../breadcrumb-group/interfaces';
import { BreadcrumbsGlobalRegistration } from '../../../internal/plugins/controllers/breadcrumbs';

export function useOwnBreadcrumbsProps() {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbGroupProps | null>(null);

  const reportOwnBreadcrumbsProps = useStableCallback(
    (props: BreadcrumbGroupProps): BreadcrumbsGlobalRegistration<BreadcrumbGroupProps> => {
      setBreadcrumbs(props);

      return {
        update: setBreadcrumbs,
        cleanup: () => setBreadcrumbs(null),
      };
    }
  );

  return { breadcrumbs, reportOwnBreadcrumbsProps };
}



// WEBPACK FOOTER //
// /src/app-layout/visual-refresh-toolbar/state/use-own-breadcrumbs-props.ts